export default {
  prLang: {
    projects: 'Projekty',
    projectsAndTeams: 'Projekty i zespoły',
    projectsApplications: 'Wnioski do projektów',
    delayedProjects: 'Projekty po terminie',
    canceledProjects: 'Projekty do anulowania',
    project: 'Projekt',
    genitiveProject: 'projektu',
    genitiveProjectWithoutSpace: 'projektu',
    accusativeProject: 'projekt',
    genitiveProjectPlural: 'projektów',
    projectNumber: 'Numer projektu',
    projectName: 'Nazwa projektu',
    internalProject: 'Projekt zlecający',
    projectList: 'Lista projektów',
    withProjects: 'z projektami',
    connectionsWithProjectsFVZ:
      'Powiązania z projektami zostaną wyjaśnione przez zespoły',
    estimate: 'Kosztorys',
    estimate2: 'kosztorysu',
    estimates: 'Kosztorysy',
    addNewProject: 'Dodawanie nowego projektu',
    newProjectName: 'Nazwa nowego projektu',
    chooseProject: 'Wybieranie projektu',
    sourceProject: 'Projekt źródłowy',
    sourceProject2: 'projekt źródłowy',
    addProject: 'Dodaj projekt',
    editProject: 'Edycja projektu',
    emptyProjectsList: 'Brak projektów w systemie.',
    projectNotFound: 'Nie znaleziono projektu o takim ID.',
    salesInvoiceToProject: 'do projektu',
    estimateItemPosition: 'Pozycja kosztorysu',
    addEstimateItemPosition: 'Dodaj pozycje kosztorysu',
    chooseEstimateItem: 'Wybieranie pozycji kosztorysu',
    estimateItemInvoiceModifyWarning:
      'Są już zapisane pozycje faktury. Czy na pewno chcesz zaktualizować pozycje kosztorysu?',
    estimateItemInvoiceTabTitle: 'Pozycje kosztorysu',
    deleteProjectWarning: 'Czy na pewno usunąć wybrany projekt?',
    deleteProjectTooltip: 'Usuń projekt',
    unsettledPurchaseInvoicesAssignedToProject:
      'Nierozliczone FVZ przypisane do projektów',
    purchaseInvoicesAssignedToProject: 'Faktury zakupu przypisane do projektów',
    orderResultProject: 'Projekt podzlecony',
    readyForInvoicing: 'Projekty gotowe do fakturowania',
    readyForCorrection: 'Projekty z ujemną kwotą do fakturowania',
    applicationUnblocks: 'Wnioski o odblokowanie kosztorysu',
    projectsListModifiedInvoiceAlert:
      'Lista projektów została zmodyfikowana. Po zapisie nastąpi zresetowanie pozycji kosztorysu oraz pozycji faktury.',
    eodInCompany: 'Komunikacja z EOD',
    eodNotInCompanyLongText:
      'W spółce {{companyName}} wyłączona jest komunikacja POK z EOD.',
    frequency: 'Częstotliwość',
    shNextStart:
      'Następne uruchomienie automatycznej wysyłki FVS do Symfonii Handel',
    ksfNextStart: 'Następne uruchomienie importu KSeF z Symfonii Handel',
    refreshFVSPaymentsNextStart:
      'Następne uruchomienie odświeżania płatności FVS',

    eodNextStart: 'Następne uruchomienie importu i eksportu FVZ z EOD',
    eodExportNextStart: 'Następne uruchomienie eksportu FVZ do EOD',
    shInCompany: 'Komunikacja z Symfonią Handel',
    shNotInCompanyLongText:
      'W spółce {{companyName}} wyłączona jest komunikacja POK z Symfonią Handel.',
    selectProjectsPurchaseInvoiceAlert:
      'Aby dodać kilka projektów należy zaznaczyć je klikając w wiersz, zaznaczone projekty zmienią kolor na żółty. Po zapisaniu zmian, wybrane projekty (jeden lub więcej) zostaną dodane',
    selectProjectPurchaseInvoiceAlertError:
      'Proszę zaznaczyć jeden lub kilka projektów.',
    askMergePositionsByProject:
      'Czy na pewno chcesz scalić pozycje według projektu?',
    sameProject: 'tego samego projektu',
    projectLabel: 'Etykieta projektu',
    projectControl: 'Kontrola projektu',
    estimateMonth: 'Miesiąc kosztorysu',
    monthRangeEstimates: 'Zakres miesięcy kosztorysów',
    teamRelatedEstimates:
      'Pozycje kosztorysu powiązane z zespołem, fazą i zakresem miesięcy',
    forProject: 'do projektu',
    projectPurchase: 'Zakup w projekcie',
    estimatePositionsSum: 'Suma pozycji kosztorysu',
    importProjectsFromFile: 'Import projektów z arkuszy',
    projectNo: 'Projekt nr sys.',
    printProjectNumber: 'Drukuj numer projektu',
    saleAndCommissionSum: 'Suma sprzedaży i prowizji kosztorysu',
    fromProject: 'z projektu',
    projectClient: 'Kontrahent projektu',
    noProjects: 'Brak projektów w systemie.',
    errCreateProjectSendApplication:
      'Założenie projektu w wybranym okresie jest już zablokowane, wyślij wniosek o założenie projektu.',
    errEditProjectSendApplication:
      'Modyfikacja dat projektu w wybranym okresie jest już zablokowana, wyślij wniosek z prośbą o zmianę okresu projektu.',
    parentProjectNumber: 'Projekt zleceniodawcy',
    askDownloadFVZ: 'Czy pobrać faktury FVZ dołączone do projektu?',
    askDownloadFVZDespiteWarnings:
      'Czy pobrać faktury FVZ dołączone do projektu pomimo następujących ostrzeżeń?',
    paePositionsList:
      'Lista pozycji w PAE dla projektu {{projectNo}} za {{date}}',
    maxDelay: 'Maks. opóźnienie projektu',
    thisProject: 'tym projektem',
    withoutTeamsProjects: 'Bez zespołów i projektów',
    settingUpProjects: 'Zakładanie projektów i uzupełnianie wniosków',
    knowledgeBase: 'Najczęstsze pytania / problemy',
    importFromProjectToProject: 'Import pozycji z projektu do projektu',
    projectOrders: 'Zamówienia do projektów',
    warningPurchaseAndSalesAmountDiff:
      'Łączna kwota zakupu z projektu zlecającego, jest różna od kwoty sprzedaży.',
    projectsByMonths: 'Projekty wg miesięcy',
    positionsProjects: 'Pozycje projektów',
    reportToBudgetByMonth: 'Raport do budżetów - wg miesięcy w projektach',
    reportProjectsReadyToInvoice: 'Raport projektów gotowych do fakturowania',
    pbProject: 'PB projektów',
    noEstimateByMonth: 'Brak kosztorysów w podanym miesiącu',
    relatedEstimatesByMonth: 'Powiązane kosztorysy',
    cloneProject: 'Klonuj projekt',
    noProjectInEstimateItems:
      'Nie wszystkie projekty są dowiązane w pozycjach kosztorysu. Po zatwierdzeniu faktury, projekty niedowiązane zostaną z niej usunięte.',
    zeroInvoiceProjectsWillBeKept:
      'Faktura na kwotę 0,00 zł. Faktura będzie dowiązana do przypisanych projektów — powiązania nie zostaną usunięte po zatwierdzeniu.',

    projectAttachments: 'Dokumenty projektu',

    umpChooseProject:
      'Wybierz kosztorys, z którego chcesz zaimportować pozycje',
    umpChoosePosition: 'Wybierz pozycje, które chcesz zaimportować do projektu',
    estimateName: 'Nazwa kosztorysu',
    intentionallyNoMediaplan:
      'Świadomy brak kosztorysu dla tego profilu w tym miesiącu',
  },
} as const;
